<template>
  <span class="rod-value__percentage" :class="rodCls">
    {{ formattedRod }}
    <span v-if="showMoney" class="rod-value__money">({{ formattedGrowthMoney }})</span>
  </span>
</template>
<script>
import { round, money } from 'shared/helpers/numberHelper';

export default {
  name: 'RodValue',
  props: {
    returnValue: {
      type: Number,
      required: true,
    },
    lastNavValue: {
      type: Number,
      default: 1,
    },
    showMoney: {
      type: Boolean,
      default: false,
    },
    isDesktop: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    rodCls() {
      const isPositive = this.isRodPositive;
      return {
        'u-fg--green': isPositive && !this.isDesktop,
        'u-fg--green-dark': isPositive && this.isDesktop,
        'u-fg--pink-coral': !isPositive && !this.isDesktop,
        'u-fg--red-brand': !isPositive && this.isDesktop,
      };
    },
    roundedRod() {
      return (parseFloat(this.returnValue) * 100).toFixed(2);
    },
    absoluteRod() {
      return Math.abs(parseFloat(this.returnValue));
    },
    absoluteRoundedRod() {
      return round(this.absoluteRod * 100);
    },
    isRodPositive() {
      return this.roundedRod >= 0;
    },
    formattedRod() {
      const sign = this.isRodPositive ? '+' : '-';
      return `${sign}${this.absoluteRoundedRod}%`.replace('.', ',');
    },
    formattedGrowthMoney() {
      return money(this.lastNavValue * this.returnValue);
    },
  },
};
</script>
